import script from "./AttendanceLegend.vue?vue&type=script&setup=true&lang=js"
export * from "./AttendanceLegend.vue?vue&type=script&setup=true&lang=js"

import "./AttendanceLegend.vue?vue&type=style&index=0&id=1dbea8f4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dbea8f4"]])

export default __exports__